import { createAsyncThunk } from '@reduxjs/toolkit';

const getExternalUsers = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/account_invitations?scope=external');
    return result;
  } catch (e) {}
};

export const fetchExtAccountInvitations = createAsyncThunk(
  'externalAccountInvites/fetch/all',
  getExternalUsers
);
